export const NO_INTERNET_CONNECTION =
  "No internet connection.\n Please check that your internet connection is working and try again.";
export const REQUEST_ERROR_503 = "The TigerConnect servers are up, but overloaded with requests. Try again later.";
export const REQUEST_ERROR_502 = "TigerConnect servers are down, or being upgraded.";
export const UNKNOWN_ERROR =
  "Oops! Something went wrong! Automatic report has been send to the TigerConnect tech team to improve your experience.";
